import { useState } from "react";

import "./stylesGamePassModal.css";

import { CloseOutlined } from "@ant-design/icons";

import { AppStrings } from "../../../../../utils/constants/AppStrings";
import {
  getApiErrorMessage,
  getApiSuccessMessage,
} from "../../../../../utils/ErrorUtils";
import ToggleSwitch from "../../../../CommonComponents/ToggleSwitch/ToggleSwitch";
import createPrivateAdminPanelInstance from "../../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../../api/ApiRoutes";
import { message } from "antd";
import RebetLoader from "../../../../CommonComponents/RebetLoader/RebetLoader";

function GamePassModal({ handleCancel, data, refreshUserData }) {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
    false
  );
  const [gamePassEnabled, setGamePassEnabled] = useState(data?.game_pass_enabled ?? true);
  const [gamePassPremiumEnabled, setGamePassPremiumEnabled] = useState(data?.game_pass_premium_enabled ?? true);
  const [isApiRunning, setIsApiRunning] = useState(false);
  
  const onCancel = () => {
    handleCancel();
  };

  const handleGamePassChange = (checked) => {
    setGamePassEnabled(checked.is_active);
  };

  const handleGamePassPremiumChange = (checked) => {
    setGamePassPremiumEnabled(checked.is_active);
  };

  const onSaveGamePassChange = async (updatedFlag) => {
    setIsApiRunning(true);
    const updatedOption = updatedFlag.is_active;

    const payload = {
      game_pass_enabled: updatedOption,
    };

    try {
      const res = await PrivateAdminPanelInstance.patch(
        API_ROUTES.UPDATE_USER_GAME_PASS_STATUS.replace(
          "{user_id}",
          data.user_id
        ),
        payload
      );

      await refreshUserData({ game_pass_enabled: updatedOption });

      setGamePassEnabled(updatedOption);

      message.success(
        getApiSuccessMessage(res, AppStrings.PAM_GENERIC_REQUEST_SUCCEEDED)
      );
    } catch (error) {
      message.error(getApiErrorMessage(error, AppStrings.PAM_GENERIC_REQUEST_FAILED));
      console.error("Update error:", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  const onSaveGamePassPremiumChange = async (updatedFlag) => {
    setIsApiRunning(true);
    const updatedOption = updatedFlag.is_active;

    const payload = {
      game_pass_premium_enabled: updatedOption,
    };

    try {
      const res = await PrivateAdminPanelInstance.patch(
        API_ROUTES.UPDATE_USER_GAME_PASS_PREMIUM_STATUS.replace(
          "{user_id}",
          data.user_id
        ),
        payload
      );

      await refreshUserData({ game_pass_premium_enabled: updatedOption });
      
      setGamePassPremiumEnabled(updatedOption);

      message.success(
        getApiSuccessMessage(res, AppStrings.PAM_GENERIC_REQUEST_SUCCEEDED)
      );
    } catch (error) {
      message.error(getApiErrorMessage(error, AppStrings.PAM_GENERIC_REQUEST_FAILED));
      console.error("Update error:", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  return (
    <div className="game-pass-modal-container">
      <div className="modal-header">
        <div className="modal-header-title">
          <h2 className="modal-title"> {AppStrings.GAME_PASS_TOGGLE}</h2>
        </div>
        <CloseOutlined onClick={handleCancel} className="close-icon" />
      </div>

      <div className="modal-content">
        <div className="modal-content-title">
          <span>
            {AppStrings.USER}: {data.username}
          </span>
        </div>
        <div className="transaction-info-item">
          <span>{AppStrings.GAME_PASS_ENABLED}?</span>
          <div className="game-pass-toggle-container">
            <span
              className={`game-pass-toggle-status ${
                gamePassEnabled ? "enabled" : "disabled"
              }`}
            >
              {gamePassEnabled ? "Yes" : "No"}
            </span>
            <ToggleSwitch
              status={gamePassEnabled}
              onChange={handleGamePassChange}
              updateEventCode={onSaveGamePassChange}
              data={data}
            />
          </div>
        </div>
        <div className="transaction-info-item">
          <span>{AppStrings.GAME_PASS_PREMIUM_ENABLED}?</span>
          <div className="game-pass-toggle-container">
            <span
              className={`game-pass-toggle-status ${
                gamePassPremiumEnabled ? "enabled" : "disabled"
              }`}
            >
              {gamePassPremiumEnabled ? "Yes" : "No"}
            </span>
            <ToggleSwitch
              status={gamePassPremiumEnabled}
              onChange={handleGamePassPremiumChange}
              updateEventCode={onSaveGamePassPremiumChange}
              data={data}
            />
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <div className="buttons">
          <button className="cancel-button" onClick={onCancel} disabled={isApiRunning}>
            {AppStrings.CLOSE}
          </button>
          <button className="save-button" disabled={isApiRunning}>
            {isApiRunning ? <RebetLoader height={"20px"} width={"20px"} /> : AppStrings.SAVE}
          </button>
        </div>
      </div>
    </div>
  );
}

export default GamePassModal;

